import React from 'react';
import ServiceHero from '../../components/service/ServiceHero';
import QuoteForm from '../../components/home/QuoteForm';
import ServiceTrusted from '../../components/service/ServiceTrusted';
import HireOnDemand from '../../components/Hire/HireOnDemand';
import ModelsSection from '../../components/home/ModelsSection';
import HireTable from '../../components/Hire/HireTable';
import HirededicatedBIMmodelers from '../../components/Hire/HirededicatedBIMmodelers';
import HireAdvantages from '../../components/Hire/HireAdvantages';
import OnboardingSection from '../../components/home/OnboardingSection';
import ProjectsSection from '../../components/home/ProjectsSection';
import TestimonialsSection from '../../components/home/TestimonialsSection';
import BestArchitectureSection from '../../components/home/BestArchitectureSection';
import IndustriesSection from '../../components/home/IndustriesSection';
import SoftwaresSection from '../../components/home/SoftwaresSection';
import AwardsSection from '../../components/home/AwardsSection';
import FAQSection from '../../components/home/FAQSection';
import BlogsSection from '../../components/home/BlogsSection';
import ContactSection from '../../components/home/ContactSection';

import experiencedImg from '../../assets/img/indus/Experienced team.png';
import techEdgeImg from '../../assets/img/indus/Technological Advantage.png';
import communicationImg from '../../assets/img/indus/Effective Communication.png';
import fasterMarketImg from '../../assets/img/indus/Faster Time to Market.png';
import qualityStandardsImg from '../../assets/img/indus/High-Quality Standards.png';
import bestValueImg from '../../assets/img/indus/Best Value.png';

const HireBIMModelers = () => {
    const bimCoreValues = [
        {
            title: "Deep Expertise",
            desc: "Our team has years of professional experience in BIM modeling. We are familiar with the US building codes and standards. That is, your projects are correct and compliant in the first place.",
            icon: <div className="anim-float"><img src={experiencedImg.src || experiencedImg} alt="Expertise" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /></div>
        },
        {
            title: "Advanced Technology",
            desc: "We apply the recent BIM software and tools. This enables us to provide accurate, data-driven models that enhance project coordination and minimize on-site errors. You can see your project well in advance of construction.",
            icon: <div className="cog-spin"><img src={techEdgeImg.src || techEdgeImg} alt="Tech" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /></div>
        },
        {
            title: "Cost-Effective Solutions",
            desc: "Our BIM solution saves you significant overhead when you outsource to us. You do not incur the cost of in-house software, hardware, or specialized training licenses. Actually, our services are affordable without compromising on quality.",
            icon: <div className="dollar-float"><img src={bestValueImg.src || bestValueImg} alt="Value" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /></div>
        },
        {
            title: "Faster Turnaround Times",
            desc: "Our streamlined processes and our hardworking team will ensure your projects are delivered on time. We help you meet strict deadlines. This ensures that your entire project is not delayed at a very high cost.",
            icon: <div className="anim-float"><img src={fasterMarketImg.src || fasterMarketImg} alt="Speed" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /></div>
        },
        {
            title: "Seamless Collaboration",
            desc: "We fit well into your current team. Consider us as a part of your office. We send you to the point and provide frequent feedback, simplifying the whole process.",
            icon: <div className="chat-bounce"><img src={communicationImg.src || communicationImg} alt="Collaboration" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /></div>
        },
        {
            title: "Scalable Resources",
            desc: "Whether you have a small project or a set of large-scale developments, we can scale our services to meet your specific requirements. Naturally, this adaptability is a benefit of having the right amount of support at all times.",
            icon: <div className="award-shine"><img src={qualityStandardsImg.src || qualityStandardsImg} alt="Scale" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /></div>
        }
    ];

    return (
        <div className="hire-bim-modelers-page">
            <ServiceHero
                overline="Hire Dedicated BIM Modelers"
                staticTitle={<> <span className="text-primary">Scale Your Projects with</span> Expert BIM Modelers <br /> — Without Hiring In-House</>}
                description={<>
                    Outsource your BIM modeling requirements to highly skilled professionals, hire dedicated bim modelers and deliver <br />
                    accurate, coordinated, and construction-ready models—faster and more cost-effectively. <br /><br />
                    We help AEC firms across the US reduce project costs, eliminate clashes, and accelerate delivery <br />
                    timelines with reliable BIM support.
                </>}
                buttonText="Hire BIM modelers now"
                typingWords={[]}
            />
            <QuoteForm />
            <ServiceTrusted
                title={<>Hire <span className="text-primary">Experts BIM</span> Modelers for Your Project</>}
                paragraphs={[
                    "We provide skilled BIM modelers who create accurate digital models of your buildings. Our BIM experts help you visualize the project, catch clashes early, and simplify the construction process.",
                    "Hiring our modelers improves efficiency and reduces costly errors. It also ensures better team collaboration. We deliver precise models that support your project from start to finish. Partner with us for reliable BIM modeling.",
                    "Hiring in-house BIM talent is expensive, time-consuming, and limiting.",
                    "We have a smarter alternative.",
                    "When you hire from us, you get:",
                    "✔ BIM specialists committed to your project.",
                    "✔ Up to 60% cost savings compared to in-house hiring.",
                    "✔ Flexible scaling — hire 1 modeler or a full team.",
                    "✔ Rapid turnaround and good quality control.",
                    "✔ Time zone compatibility in the US."
                ]}
                buttonText="Book a Meeting"
            />
            <style jsx>{`
                .hire-bim-modelers-page :global(.trusted-new-content) {
                    gap: 0 !important; /* Disabling the component's default gap to gain full control */
                }
                
                /* Standard gap for all paragraphs */
                .hire-bim-modelers-page :global(.trusted-new-content p) {
                    margin-bottom: 20px !important;
                }

                /* Custom control for specific lines (paragraphs) */
                /* 1st paragraph (Intro) */
                .hire-bim-modelers-page :global(.trusted-new-content p:nth-child(1)) { margin-bottom: 35px !important; }
                
                /* 2nd & 3rd paragraphs */
                .hire-bim-modelers-page :global(.trusted-new-content p:nth-child(2)),
                .hire-bim-modelers-page :global(.trusted-new-content p:nth-child(3)) { margin-bottom: 30px !important; }

                /* 4th line (Small text before list) */
                .hire-bim-modelers-page :global(.trusted-new-content p:nth-child(4)) { margin-bottom: 25px !important; }

                /* 5th line ("When you hire from us, you get:") */
                .hire-bim-modelers-page :global(.trusted-new-content p:nth-child(5)) { margin-bottom: 20px !important; }

                /* List items (Checkmark lines) - Keeping them tight as previously requested */
                .hire-bim-modelers-page :global(.trusted-new-content p:nth-child(n+6)) {
                    margin-bottom: 5px !important;
                }
                
                /* Last item should have more margin to separate from the button */
                .hire-bim-modelers-page :global(.trusted-new-content p:last-child) {
                    margin-bottom: 0 !important;
                }

                .hire-bim-modelers-page :global(.industries-subtitle) {
                    max-width: 1070px !important;
                }
            `}</style>
            <HireOnDemand />
            <ModelsSection />
            <OnboardingSection />
            <HireTable />
            <HirededicatedBIMmodelers />
            <HireAdvantages />
            <ProjectsSection />
            <TestimonialsSection />
            <BestArchitectureSection />
            <IndustriesSection
                title={<> <span className="text-primary">Why We Stand Out As An</span> Outsourcing Scan to BIM Services Company?</>}
                subtitle="Numbers and figures can tell a story, but we prioritize quality above all. Our high Scan to BIM modeling standards, continuous growth, and passion for innovation help us stand out. Here’s a closer look at what makes us the right choice for your Building Information Modeling needs."
                coreValues={bimCoreValues}
            />
            <SoftwaresSection />
            <AwardsSection />
            <FAQSection
                title={<> <span className="text-primary">Frequently Asked</span> Questions</>}
                faqs={[
                    {
                        question: "How Much Does It Cost To Hire A BIM Modeler?",
                        answer: "The cost depends on the modeler's expertise and the engagement model (hourly or dedicated). Generally, you can save up to 60% compared to local in-house hiring while maintaining high-quality standards."
                    },
                    {
                        question: "Which Software Do You Use?",
                        answer: "Our team is proficient in industry-leading software including Autodesk Revit (Architecture, Structure, MEP), Navisworks, AutoCAD, and various BIM coordination platform."
                    },
                    {
                        question: "How Quickly Can You Start?",
                        answer: "We can typically assign a dedicated BIM modeler to your project within 3 to 5 business days after your specific requirements have been finalized."
                    },
                    {
                        question: "Do You Work With International Clients?",
                        answer: "Yes, we work extensively with clients across the USA, UK, Australia, and Europe. Our team is trained in international building codes and operates in flexible time zones to ensure seamless collaboration."
                    }
                ]}
            />
            <BlogsSection />
            <ContactSection />
        </div>
    );
};

export default HireBIMModelers;
